// extracted by mini-css-extract-plugin
export default {"videoCTA":"videoCTA__11SoS","videoCta":"videoCTA__11SoS"};